import {
  DrugListResultsProps,
  DrugPricesListResultsProps,
  Location,
  MemberSelectedDrug,
  MemberSelectedDrugConfiguration,
  PharmacyDetails,
} from "./interfaces";
import { request } from "./request";


export async function getDrugListAPI(payload: { search: string }, authToken: string): Promise<DrugListResultsProps> {
  return request<DrugListResultsProps>(
    {
      url: "/drug/list",
      method: "POST",
      data: payload,
    },
    authToken,
    "base",
  );
}

export async function getDrugPricesListAPI(payload: MemberSelectedDrugConfiguration, authToken: string): Promise<DrugPricesListResultsProps> {
  return request<DrugPricesListResultsProps>(
    {
      url: "/drug/prices/list",
      method: "POST",
      data: payload,
    },
    authToken,
    "base",
  );
}

export async function getDrugDetailsAPI(payload: { drug_id: number }, authToken: string): Promise<MemberSelectedDrug> {
  return request<MemberSelectedDrug>(
    {
      url: "/drug/get",
      method: "POST",
      data: payload,
    },
    authToken,
    "base",
  );
}

export async function getUserLocationAPI(payload: Location, authToken: string): Promise<Location> {
  return request<Location>(
    {
      url: "/location/geolocate",
      method: "POST",
      data: payload,
    },
    authToken,
    "base",
  );
}

export async function getPharmacyAPI(payload: { provider_id: string }, authToken: string): Promise<PharmacyDetails> {
  return request<PharmacyDetails>(
    {
      url: "/pharmacy/get",
      method: "POST",
      data: payload,
    },
    authToken,
    "base",
  );
}
